import type { IColorScheme } from './IColorScheme';
import { COLOR_SCHEMES } from './colorSchemes';
import { DEFAULT_COLOR_SCHEME_ID } from './defaultColorScheme';

/** Схема за ключем; невідомий, порожній або застарілий ключ — типова «Парламент» (як applyScheme у прототипі). */
export function findColorScheme(id: string | null | undefined): IColorScheme {
  return COLOR_SCHEMES.find((s) => s.id === id) ?? COLOR_SCHEMES.find((s) => s.id === DEFAULT_COLOR_SCHEME_ID)!;
}
